import * as Chakra from '@chakra-ui/react';
import * as React from 'react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { ReactSVG } from 'react-svg';

import { useCheckServiceAccess } from '../../api/hooks';
import { Service } from '../../api/models';

const baseName = process.env.REACT_APP_KITRON_BASENAME || '';

const ServiceCard = (props: { service: Service }) => {
    const { service } = props;
    const { isSuccess: accessGranted, isLoading: accessRequestPending } =
        useCheckServiceAccess(service.redirectUri);

    return (
        <Chakra.Grid
            templateColumns='repeat(5, 1fr)'
            templateRows='repeat(5, 1fr)'
            bg='Kitron.White'
            gap={4}
            p={8}
            borderRadius={10}
            boxShadow='0px 4px 20px 0px #001D3A26'
        >
            <Chakra.GridItem rowSpan={2} colSpan={3}>
                <Chakra.HStack spacing={4}>
                    <ReactSVG
                        src={
                            service.iconFileName.includes('http')
                                ? service.iconFileName
                                : `${baseName}/api/icon/${service.iconFileName}/`
                        }
                    />
                    <Chakra.Heading size='md'>{service.name}</Chakra.Heading>
                </Chakra.HStack>
            </Chakra.GridItem>
            <Chakra.GridItem rowSpan={1} colSpan={2}>
                <Chakra.Center>
                    <Chakra.Badge
                        color={service.textColor}
                        bg={service.color}
                        py='5px'
                        px='10px'
                        borderRadius='20px'
                    >
                        {service.serviceGroup}
                    </Chakra.Badge>
                </Chakra.Center>
            </Chakra.GridItem>
            <Chakra.GridItem rowSpan={2} colSpan={5}>
                <Chakra.Text>{service.description}</Chakra.Text>
            </Chakra.GridItem>
            <Chakra.GridItem rowSpan={1} colSpan={5} position='relative'>
                <Chakra.Button
                    variant='Primary'
                    position='absolute'
                    right={0}
                    rightIcon={<ExternalLinkIcon />}
                    onClick={() => {
                        window.location.assign(service.redirectUri);
                    }}
                    isDisabled={!accessGranted}
                    isLoading={accessRequestPending}
                >
                    Open service
                </Chakra.Button>
            </Chakra.GridItem>
        </Chakra.Grid>
    );
};

export default ServiceCard;
